(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2957"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2957"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7lF7b", function(module, exports) {

$parcel$export(module.exports, "newsletterTokenList", function () { return $a1a23427d9cdc164$export$2a509c948cb4da52; });
const $a1a23427d9cdc164$export$2a509c948cb4da52 = {
    default: '5',
    currencyComments: 'E',
    forTests: '4',
    cardTestsWithOpinions: 'P',
    cardTestsWithoutOpinions: 'Z'
};

});


var $7lF7b = parcelRequire("7lF7b");
const $c54c81d02f6f887c$export$13fbb4e6b5a93daf = ()=>{
    const cleanUrl = `${window.location.origin}${window.location.pathname}`;
    if (window.history && typeof window.history.replaceState === 'function') window.history.replaceState({}, document.title, cleanUrl);
};


const $f3b35dc79fc0e198$export$2ec7f227ec1b9b43 = ()=>{
    const params = new URLSearchParams(window.location.search);
    const successCode = params.get('newsletter_consent_success') || '';
    const failedCode = params.get('newsletter_consent_fail') || '';
    const newsletterTokenListDefault = (0, $7lF7b.newsletterTokenList).default;
    const newsletterTokenListCurrencyComments = (0, $7lF7b.newsletterTokenList).currencyComments;
    const $confirmText = {
        defaultAndCurrencyComments: document.querySelector('[data-text-default]'),
        [newsletterTokenListDefault]: document.querySelector('[data-text-5]'),
        [newsletterTokenListCurrencyComments]: document.querySelector('[data-text-e]')
    };
    const getTargetCode = (success, fail)=>{
        const isPair = success === newsletterTokenListDefault && fail === newsletterTokenListCurrencyComments || success === newsletterTokenListCurrencyComments && fail === newsletterTokenListDefault;
        return isPair ? success : null;
    };
    const showTarget = (code)=>{
        const targetElement = $confirmText[code];
        if (!targetElement) return;
        $confirmText.defaultAndCurrencyComments?.setAttribute('hidden', '');
        targetElement.removeAttribute('hidden');
    };
    const target = getTargetCode(successCode, failedCode);
    if (target) showTarget(target);
    (0, $c54c81d02f6f887c$export$13fbb4e6b5a93daf)();
};


(0, $f3b35dc79fc0e198$export$2ec7f227ec1b9b43)();

})();
//# sourceMappingURL=script.js.map
